import { Component, input, OnInit, output, signal } from '@angular/core';

@Component({
  selector: 'app-select-dialog',
  standalone: false,
  templateUrl: './select-dialog.component.html',
  styleUrl: './select-dialog.component.css',
})
export class SelectDialogComponent implements OnInit {

  list = input.required<ISelectDialogListItem[]>();
  value = input<number | string>(null);
  onSelected = output<ISelectDialogListItem>();
  label = input<string>('');
  dimensions = input<{ width: number, height: number }>(null);
  heading = input<string>('');
  buttonLabel = signal<string>('Select');
  showDialog = signal(false);
  hasRAG = signal(false);
  size = input<'small' | 'medium'>('medium');


  ngOnInit(): void {
    //const label = String(this.list().find(i => i.id === this.value()) ?? 'Select');
    const label = this.label() ?? 'Select';
    this.buttonLabel.set(label);
    this.hasRAG.set(this.list().some(i => i.rag));
  }

  clickRow(item: ISelectDialogListItem) {
    this.onSelected.emit(item);
    this.showDialog.set(false);
    if (!this.label()) {
      // Set to selected unless label set to always show
      this.buttonLabel.set(String(item.label ?? item.title));
    }
  }

  clickButton() {
    this.showDialog.set(!this.showDialog());
  }
}

export interface ISelectDialogListItem {
  id: number | string;
  label?: string;
  title?: string;
  isRag?: boolean;
  rag?: string;
  isSelected?: boolean;
}
